/**
 * FAQs 折叠展开功能
 * 管理常见问题部分的显示和隐藏
 */

class FAQsToggle {
  constructor() {
    this.isExpanded = false;
    this.button = null;
    this.grid = null;
    this.mask = null;
    this.arrow = null;
    this.hiddenItems = [];

    this.init();
  }

  init() {
    // 等待DOM加载完成
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupElements());
    } else {
      this.setupElements();
    }
  }

  setupElements() {
    this.button = document.getElementById('faqs-toggle-btn');
    this.grid = document.getElementById('faq-grid');
    this.mask = document.getElementById('faq-mask');
    this.arrow = this.button?.querySelector('.faq-arrow');

    if (!this.button || !this.grid || !this.mask) {
      console.warn('[FAQs] Required elements not found');
      return;
    }

    // 获取所有隐藏的FAQ项目
    this.hiddenItems = this.grid.querySelectorAll('.faq-hidden');

    // 设置初始状态
    this.setupInitialState();

    // 绑定点击事件
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggle();
    });

    console.log('[FAQs] Toggle functionality initialized');
  }

  setupInitialState() {
    if (this.hiddenItems.length === 0) {
      // 如果没有隐藏项目，隐藏切换按钮
      this.button.style.display = 'none';
      return;
    }

    // 设置初始折叠状态
    this.isExpanded = false;
    this.updateDisplay();
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
    this.updateDisplay();

    // 更新按钮的aria-expanded属性
    this.button.setAttribute('aria-expanded', this.isExpanded.toString());

    console.log('[FAQs] Toggled to:', this.isExpanded ? 'expanded' : 'collapsed');
  }

  updateDisplay() {
    if (!this.grid || !this.mask || !this.arrow) {return;}

    if (this.isExpanded) {
      // 展开状态
      this.hiddenItems.forEach(item => {
        item.style.display = 'block';
        // 添加展开动画
        setTimeout(() => {
          item.classList.remove('faq-hidden');
          item.classList.add('faq-visible');
        }, 10);
      });

      // 隐藏遮罩
      this.mask.style.height = '0px';
      this.mask.style.opacity = '0';

      // 旋转箭头（向下）
      this.arrow.style.transform = 'rotate(90deg)';

      // 更新网格高度
      this.grid.style.maxHeight = 'none';
      this.grid.style.overflow = 'visible';

    } else {
      // 折叠状态
      this.hiddenItems.forEach(item => {
        item.classList.remove('faq-visible');
        item.classList.add('faq-hidden');
        // 延迟隐藏以允许动画
        setTimeout(() => {
          item.style.display = 'none';
        }, 300);
      });

      // 显示遮罩
      this.mask.style.height = '100px';
      this.mask.style.opacity = '1';

      // 旋转箭头（向右）
      this.arrow.style.transform = 'rotate(0deg)';

      // 限制网格高度
      this.grid.style.maxHeight = '400px';
      this.grid.style.overflow = 'hidden';
    }
  }

  // 公共方法：程序化控制展开/折叠
  expand() {
    if (!this.isExpanded) {
      this.toggle();
    }
  }

  collapse() {
    if (this.isExpanded) {
      this.toggle();
    }
  }

  // 获取当前状态
  getState() {
    return {
      isExpanded: this.isExpanded,
      hiddenItemsCount: this.hiddenItems.length
    };
  }
}

// 自动初始化
let faqsToggle = null;

if (typeof window !== 'undefined') {
  faqsToggle = new FAQsToggle();

  // 将实例暴露到全局作用域以便调试
  window.faqsToggle = faqsToggle;
}

// 导出类和实例
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { FAQsToggle, faqsToggle };
}